import { useState,ChangeEvent, useEffect,MouseEvent, useContext } from 'react';
import { Modal, Button} from 'rsuite';
import { toast} from 'react-toastify';
import { Article } from '../../../common.interface';
import { MdCloudUpload } from "react-icons/md";
import axios from 'axios';
import useArticle from '../../../hooks/useArticles';
import Input from '../../../component/Input'
import TextArea from '../../../component/TextArea';
import { UserContext } from '../../../context/userContext';


const CustomArticleModal = ({open,handleOpen,data,setData}:{open:boolean,handleOpen:any,data:Article,setData:any}) => {
  const {user} = useContext(UserContext);
    const {
        updateArticle,
        createArticle,
       } = useArticle();
    const acceptedExt = ["image/png", "image/jpg", "image/jpeg"];
    const [imageState,setImageState] = useState({selectedImage:null as File|null,
      preview:null as string|null,
      picFile:null as File|null})

    const {_id,imageUrl,title,content,author} = data;
   
    const reset = () => {
        setData(
            {'imageUrl':'',
        'title':'',
        'content':'',
        'author':'',}
        )
        setImageState({
          selectedImage:null,
          preview:null,
          picFile:null,
        })
  
    }

    useEffect(() => {
        // console.log("=====================useremail======================");
        // console.log(user[0]);
        // console.log(donationFormData);
        if (!imageState.selectedImage) {
          setImageState((prev)=>({...prev,preview:null}))
          return;
        }
        // create the preview
        const objectUrl = URL.createObjectURL(imageState.selectedImage!);
        setImageState((prev)=>({...prev,preview:objectUrl}))
    
        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl);
      }, [imageState.selectedImage]);


    const handleChange = (e:ChangeEvent<HTMLInputElement| HTMLTextAreaElement>) => {
      // console.log('===============changing=============');
        e.preventDefault();
        const { value, id} = e.target;
        if(id === 'articleImage'){
          const inputElement = e.target as HTMLInputElement;
          const maxSize = 5 * 1024 * 1024; // 5MB in bytes
          if (inputElement.files&& inputElement.files.length>0 && acceptedExt.includes(inputElement.files[0].type)&&inputElement.files[0].size<maxSize) {
            const imageFile:FileList = inputElement.files
            setImageState((prev)=>({...prev,selectedImage:imageFile[0],picFile:imageFile[0]}))

          }else{
            toast.error('File size exceeds 5MB limit.', {
              position: toast.POSITION.TOP_LEFT
            }); 
          }
        } 
        else{
            setData((prev: Article)=>({...prev,[id]:value}))
          }
        }

    const handleImageUpload = async() =>{
        // console.log('==================uploading image==============')
        if(imageState.picFile){
        try {
          const mypic = new FormData();
          mypic.append("mypic",imageState.picFile)
          const imageResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}/image/create`,
          mypic,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          if (imageResponse.status===200){

            // console.log(`image response`,imageResponse.data.data.imageUrl)
              const imageUrl = imageResponse.data.data.imageUrl;
              return imageUrl;
          }
          else{
              return null;
          }
        } catch (error) {
          toast.error(`${(error as any).message}`, {
            position: toast.POSITION.TOP_LEFT
          });
          return null;
        }
    }
    else{
        return ''
    }

    }

    const handleCreateArticle = async(e:MouseEvent<HTMLButtonElement>) =>{
      e.preventDefault()
            // console.log('==============creaating===========');
            // console.log('title',title);
            // console.log('company',author);
            // console.log('amount',content);

            const imageUrl = await handleImageUpload();

            if (imageUrl!=null) { 

                try {

                    const newData:Article = {title,content,author,'imageUrl':imageUrl?imageUrl:'',publisherRef:user._id}
                    const response =await axios.post(`${process.env.REACT_APP_BASE_URL}/article/create`,newData);
                    if(response.status ===201){
                        createArticle(response.data.data);
                        //handleOpen();
                        //reset();
                        handleArticleOpen();
                        toast.success("Article Created !", {
                            position: toast.POSITION.TOP_CENTER
                          });
                    }
                    else{
                        toast.error("Couldn't create Article !", {
                            position: toast.POSITION.TOP_CENTER
                          });
                    }
                    
                } catch (error) {
                    toast.error(`${(error as any).message}`, {
                        position: toast.POSITION.TOP_LEFT
                      });                
                }     
            }    
        else{
          toast.error(`Error creating Article, Couldn't upload image`, {
            position: toast.POSITION.TOP_LEFT
          });  
        }
    }

    const handleUpdate = async(e:MouseEvent<HTMLButtonElement>) =>{
      // console.log('============updating==========')
      e.preventDefault()
        const newData:Article = {title,content,author,'imageUrl':imageUrl?imageUrl:''}

        try {
            const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/article/update/${_id}`,newData);
            if(res.status===200){
              // console.log('updated data',res.data)
                updateArticle(res.data.data);
                //handleOpen();
                //reset();
                handleArticleOpen();

                toast.success(" Article Updated!", {
                        position: toast.POSITION.TOP_CENTER
                });
            }
            else{
                toast.error(`Error updating Article`, {
                    position: toast.POSITION.TOP_LEFT
                  });       
            }  
         } catch (error) {
            toast.error(`${(error as any).message}`, {
                position: toast.POSITION.TOP_LEFT
              });       
          // console.log('update updating error',error);
          throw error;
        }
    
    }

    const handleDelete = async(e:MouseEvent<HTMLButtonElement>) =>{
      // console.log('============deleting==========')
      e.preventDefault()
        try {
          const header = {
            'headers':{
              'Authorization':`Bearer ${user.accessToken}`
            }
          }
            const res = await axios.delete(`${process.env.REACT_APP_BASE_URL}/article/delete/${_id}`,header);
            if(res.status===200){
              // console.log('Delete data',res.data)
                // updateArticle(res.data);
                //handleOpen();
                //reset();
                handleArticleOpen();
                toast.success(" Article Deleted!", {
                        position: toast.POSITION.TOP_CENTER
                });
            }
            else{
                toast.error(`Action Not Permitted,Contact Admin`, {
                    position: toast.POSITION.TOP_LEFT
                  });       
            }
            
         } catch (error) {
              const axiosError = error as any;
              const displayMessage = axiosError.response?.data.message??axiosError.message;
            toast.error(`${displayMessage}`, {
                position: toast.POSITION.TOP_LEFT
              });       
          // console.log('update updating error',error);
        }
    }

    const handleArticleOpen = () =>{
      handleOpen()
      reset()
    }

  return (
    <>
      <div>
        <Modal
            open={open}
            onClose={handleArticleOpen}  
        >
            <Modal.Header>
            <Modal.Title> <p className='font-semibold' >{_id?'Update Article':'Create Article'}</p> </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <form className='flex flex-col'>
            <div className="border rounded mb-2">
              {_id?(
                <img
                        src={imageUrl!?`${imageUrl}`:''}
                        alt="Article header"
                        className="h-52 w-full"
                      />):(
                        <div className='flex h-52'>
                          <div className="flex items-center w-full justify-center">
                          <label htmlFor="articleImage">
                                {
                                    imageState.selectedImage != null ? (
                                      <img
                                        src={imageState.preview!}
                                        alt="Article header"
                                        className="h-52"
                                      />
                                    ) : (
                                      <MdCloudUpload size={80} className="CloudImage" />
                                    )
                                  

                                }
                    
                            </label>
                        </div>

                          <input
                            type="file"
                            name="articleImage"
                            id="articleImage"
                            onChange={handleChange}
                            accept="image/jpeg, image/png, image/jpg"
                            hidden
                          />
                        </div>)
                      }
              </div>
                
                <label htmlFor="title">Title</label>
                <Input value={title} id="title" type='text' name='title' onChange={handleChange} required={true} placeholder={'Title'} />
                <label htmlFor="content">Content</label>
                <TextArea id="content" value={content} name='content' onChange={handleChange} required={true} placeholder={'Enter Content'}  />
                <label htmlFor="author">Author</label>
                <Input value={author} type='text' id="author" name='author' onChange={handleChange} required={true} placeholder={'Author'} />
            </form>
            </Modal.Body>
            <Modal.Footer>
              {_id&&<Button onClick={handleDelete} appearance="primary" color="red">
                {_id&&'Delete'}
            </Button>}
            <Button onClick={_id?handleUpdate:handleCreateArticle} appearance="primary" color="orange">
                {_id?'Update':'Publish'}
            </Button>
            </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default CustomArticleModal;